<template>
    <div class="alert-container" :class="type">
        <div class="alert-background"></div>
        <div class="alert-border"></div>
        <div class="alert-icon-border"></div>
        <div class="icon-container">
            <unicon v-if="type === 'success'" name="check-circle" fill="#ffffff"
                    class="icon"></unicon>
            <unicon v-else-if="type === 'warning'" name="exclamation-circle" fill="#ffffff" hover-fill="#00B6ED"
                    class="icon"></unicon>
            <unicon v-else-if="type === 'error'" name="times-circle" fill="#ffffff" hover-fill="#00B6ED"
                    class="icon"></unicon>
            <unicon v-else-if="type === 'progressing'" name="clock" fill="#ffffff" hover-fill="#00B6ED"
                    class="icon"></unicon>
            <unicon v-else-if="type === 'info'" name="info-circle" fill="#ffffff" hover-fill="#00B6ED"
                    class="icon"></unicon>
        </div>
        <div class="alert-content">
            <div>
                <slot/>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Alert",
    props: {
        type: {
            type: String,
            default: 'success'
        }
    },
}
</script>

<style lang="scss" scoped>
.alert-container {
    position: relative;
    display: flex;
    border-radius: 4px;
    padding: 24px 16px 16px 16px;
    overflow: hidden;
    margin-bottom: 10px;
    border: thin solid currentColor;
    min-height: 70px;
}

.alert-background {
    position: absolute;
    width: 100%;
    height: 100%;
    background: currentColor;
    opacity: 0.1;
    top: 0;
    left: 0;
}

.alert-border {
    border-radius: inherit;
    border-color: currentColor;
    border-style: solid;
    border-width: 0;
    opacity: 0.38;
    pointer-events: none;
    top: 0;
    left: 0;
    border-top-width: 8px;
    position: absolute;
    width: 100%;
    height: 100%;
}

.icon-container, .alert-icon-border {
    position: absolute;
}

.icon-container {
    top: 1.5rem;
    left: 1.55rem;
}

.alert-icon-border {
    border-radius: 100%;
    border-color: currentColor;
    opacity: 0.5;
    border-width: 25px;
    border-style: solid;
    height: 50px;
    aspect-ratio: 1 / 1;
    top: 1rem;
    left: 1rem;
}

.alert-content {
    display: flex;
    align-items: center;
    margin-left: 4rem;
    margin-top: 8px;
}

.icon {
    position: relative;
    top: 1px;
    margin-right: .5rem;
    transition: all 0.3s ease-in-out;

  :deep( svg ){
        width: 2rem;
        height: 2rem;
    }

}

.success {
    color: #4CAF50;
}

.info {
    color: #00b6ed;
}

.progressing {
    //color: #607D8B;
    color: #3F51B5;
}

.warning {
    color: #FF9800;
}

.error {
    color: #F44336;
}

</style>